export default __webpack_public_path__ + "static/media/icon_share.085bd47b.svg";